import React from 'react';
import Venus from '../../../Report/venus';

export default function VenusReport() {
  return <Venus />;
}
